export const itinerary = {
  "Day 1": {
    columnTitle: "Uluru Arrival",
    columnDay: "Day 1",
    activities: [
      {
        tags: ["flight"],
        id: "ayers-rock-airport",
        label: "Arrive at Ayers Rock Airport"
      },
      {
        tags: ["highlight"],
        id: "field-of-light",
        label: "Field of Light",
        imageName: "fieldOfLight.jpg",
        notes: `<p>$43 per person <br/>
        We strongly recommend pre-booking your Field of Light tours prior to arrival as spaces are limited and tours are selling out. The exhibition is located in a remote area away from the Resort and is not accessible unless booked onto one of the tours. <br/>
        Info from: <a target="_blank" href="https://www.ayersrockresort.com.au/events/detail/field-of-light-uluru">Ayers Rock Resort Field of Uluru</a></p>
        <br/><p>Note: We actually decided to do <a target="_blank" href="https://www.ayersrockresort.com.au/experiences/detail/sounds-of-silence">Sounds of Silence</a>. It's a bit more expensive but we loved the experience.</p>
        `
      },
      {
        tags: ["sleep"],
        id: "ayers-rock-resort",
        label: "Ayers Rock Resort"
      }
    ]
  },
  "Day 2": {
    columnTitle: "Uluru",
    columnDay: "Day 2",
    activities: [
      {
        tags: ["highlight"],
        id: "uluru-sunrise-viewing",
        label: "Sunrise Viewing Uluru",
        imageName: "uluru.jpg",
        notes: `Note: We drove to the sunrise viewing area before the base walk. Remember to make it 30 mins before the actual time that is specified as sunrise. We just arrived there at the time of sunrise and so we kind of missed the beginning of it. It's a bit full of people but still pretty cool to watch.`
      },
      {
        tags: ["highlight"],
        id: "uluru-base-walk",
        label: "Uluru Base Walk",
        imageName: "uluruBaseWalk.jpg",
        notes: `<h4> Grade 3 | Moderate</h4>
        <p>10.6km full circuit, 3.5hours </p>
        <p>The Uluru base walk is about 10 km of track that takes you around the whole circumference of the rock.</p>
        <p>You can take the entire Uluru base walk, or just concentrate on one or more of its sections, depending on how much time you have, your level of fitness and the weather.</p>
        <p>We recommend you start the base walk from the Mala carpark in the early morning, while it’s cool. Facing the rock, start by going clockwise.<br/>
        Each section will look and feel completely different. Some areas are surprisingly green and lush, providing plenty of wildlife and bush tucker spotting opportunities, while other sections feel open and vast, with little shade.<br/>
        Info from : <a target="_blank" href="https://parksaustralia.gov.au/uluru/do/walks/uluru-base-walk/">Parks Australia Uluru Base Walk</a>
        </p>`
      },
      {
        tags: [],
        id: "cultural-center",
        label: "Cultural Center"
      },
      {
        tags: [],
        id: "lake-amadeus",
        label: "Lake Amadeus"
      },
      {
        tags: ["sleep"],
        id: "ayers-rock-resort",
        label: "Ayers Rock Resort"
      }
    ]
  },
  "Day 3": {
    columnTitle: "Uluru > Kings Canyon",
    columnDay: "Day 3",
    activities: [
      {
        tags: ["highlight"],
        id: "kata-tjuta",
        label: "Kata Tjuta",
        imageName: "kataTjuta.jpg"
      },
      {
        tags: ["highlight"],
        id: "valley-of-the-winds",
        label: "Valley of the Winds Hike",
        imageName: "valleyOfTheWinds.jpg",
        notes: `<h4>Grade 4 | Moderate to difficult </h4>
        <p>7.4 km, 4 hours</p>
        <p>The Valley of the Winds walk lets visitors immerse themselves among Kata Tjuta’s domes. It also features unparalleled views of the spectacular Mars-like landscape surrounding Kata Tjuta from two lookout points along the track.

        This walk is classed as Grade 4. It is steep, rocky and difficult in places, so please be careful and take your time.
        Info from: <a target="_blank" href="https://parksaustralia.gov.au/uluru/do/walks/valley-of-the-winds/">Parks Australia Valley of the Winds</a>
        </p>
        
        <p>Note: Even though Uluru is more popular this one was amazing, you truly feel like you are out of this earth. It's something that you can't miss if you are in the area. Also we did it around 6am and it was even better because we were the only ones there.</p>
        <p>This is a culturally sensitive area so I tried to pick photos that don't show it as much but it doesn't do justice to what you see in person.</p>
        `
      },
      {
        tags: ["extras"],
        id: "mount-conner",
        label: "Mount Conner Lookout",
        imageName: "mountConner.jpg"
      },
      {
        tags: ["drive"],
        id: "kata-tjuta-kings-canyon",
        label: "Kata Tjuta - Kings Canyon Resort"
      },
      {
        tags: ["sleep"],
        id: "kings-canyon-resort",
        label: "Kings Canyon Resort"
      }
    ]
  },
  "Day 4": {
    columnTitle: "Kings Canyon > Alice Springs",
    columnDay: "Day 4",
    activities: [
      {
        tags: ["highlight"],
        id: "rim-walk",
        label: "Rim Walk",
        imageName: "rimWalk.jpg",
        notes: `<p>The six-kilometre circuit will take you down into the Garden of Eden, a beautiful rockhole surrounded by rare plants, before ascending to 360 degree panoramic views over the red sand dunes.</p>

        <p>Suitable for relatively fit travellers, the first 500 steps of the Rim Walk is the most challenging, but the view from the top is what will really take your breath away.</p>
        
        <p>3-4 hours and is best tackled at sunrise before the temperature rises.</p>
        <p>Note: We actually started climbing up while it was still dark. During sunrise we were already at the top which makes for a beautiful sight.</p>
        `
      },
      {
        tags: ["drive"],
        id: "kings-canyon-alice-springs",
        label: "Kings Canyon - Alice Springs",
        imageName: "driveAliceSprings.jpg",
        notes: `<p>There are several ways you can make your way to Alice Springs. The fastest one is going back towards Uluru and taking the Lasseter Highway. You can also take the Mereenie Loop Road and from there decide either to go through the Namatjira Drive or Larapinta Drive. You could also travel through the Ernest Giles Road. </p>
        <p>We decided to take the Mereenie Loop Road which is an unsealed road and then through Namatjira Drive to make stops on the gorges along the way. Also don't trust google maps times, they are exaggerated it takes less time.</p>
        <p><strong>If you decide to take Mereenie Loop you need to have a 4WD and buy a permit that costs around 6 AUD per car.</strong> You can purchase it at Kings Canyon Resort. </p>`
      },
      {
        tags: ["drive"],
        id: "mereenie-loop",
        label: "Mereenie Loop",
        imageName: "mereenieLoop.jpg",
        notes: `<p>If you decide to take Mereenie Loop you need to have a 4WD and buy a permit that costs around 6 AUD per car. You can purchase it at Kings Canyon Resort. As mentioned in Kings Canyon - Alice Springs there are alternative routes if you don't have a 4WD.</p>
        <p>It was a pretty straightforward straight road. It can get a bit tiring towards the end since its pretty much the same all the way. But it's still a cool experience and most direct route to the gorges we wanted to see.</p>`
      },
      {
        tags: ["stop"],
        id: "tnorala",
        label: "Tnorala"
      },
      {
        tags: ["stop", "extras"],
        id: "redbank-gorge",
        label: "Redbank Gorge"
      },
      {
        tags: ["stop", "highlight"],
        id: "glen-helen-gorge",
        label: "Glen Helen Gorge",
        imageName: "glenHelen.jpg"
      },
      {
        tags: ["stop", "extras"],
        id: "ormiston-gorge",
        label: "Ormiston Gorge"
      },
      {
        tags: ["stop", "extras"],
        id: "ochre-pits",
        label: "Ochre Pits"
      },
      {
        tags: ["stop", "extras"],
        id: "serpentine-gorge",
        label: "Serpentine Gorge"
      },
      {
        tags: ["stop", "highlight"],
        id: "ellery-creek-gorge",
        label: "Ellery Creek Gorge",
        imageName: "elleryCreek.jpg"
      },
      {
        tags: ["stop", "highlight"],
        id: "standley-chasm",
        label: "Standley Chasm"
      },
      {
        tags: ["stop", "highlight"],
        id: "simpsons-gap",
        label: "Simpsons Gap",
        imageName: "simpsonsGap.jpg"
      },
      {
        tags: ["sleep"],
        id: "double-tree",
        label: "Double Tree by Hilton Alice Springs"
      }
    ]
  },
  "Day 5": {
    columnTitle: "Alice Springs > Tennant Creek",
    columnDay: "Day 5",
    activities: [
      {
        tags: ["drive"],
        id: "alice-springs-tennant-creek",
        label: "Alice Springs - Tennant Creek"
      },
      {
        tags: ["stop"],
        id: "barrow-creek-hotel",
        label: "Barrow Creek Hotel",
        imageName: "barrowCreek.jpg",
        notes: `Grab a beer! And some petrol 😊`
      },
      {
        tags: ["stop"],
        id: "wycliffe-well",
        label: "Wycliffe Well",
        imageName: "wycliffeWell.jpg"
      },
      {
        tags: ["stop"],
        id: "devils-marbles",
        label: "Devil's Marbles",
        imageName: "devilsMarbles.jpg",
        notes: `<p>The Devils Marbles are a collection of massive granite boulders strewn across a valley south of Tennant Creek. Standing at up to 6 metres high and formed over millions of years, they continue to crack and change.</p>`
      },
      {
        tags: ["sleep"],
        id: "goldfields",
        label: "Goldfields Hotel Motel (Tennant Creek)"
      }
    ]
  },
  "Day 6": {
    columnTitle: "Tennant Creek > Katherine",
    columnDay: "Day 6",
    activities: [
      {
        tags: ["drive"],
        id: "tennant-creek-katherine",
        label: "Tennant Creek - Katherine"
      },
      {
        tags: ["stop", "eat"],
        id: "daly-waters-pub",
        label: "Daly Waters Pub",
        imageName: "dalyWaters.jpg",
        notes: `Historic Pub, grab some brekkie and a beer!`
      },
      {
        tags: ["stop", "highlight"],
        id: "mataranka-thermal-pools",
        label: "Mataranka Thermal Pools",
        imageName: "mataranka.jpg",
        notes: `Awesome place to have a swim. Water is super clear and perfect temp to refresh a bit. It was full of bats when we were there so it was even more amazing.`
      },
      {
        tags: ["sleep"],
        id: "pine-tree-motel",
        label: "Pine Tree Motel (Katherine)"
      }
    ]
  },
  "Day 7": {
    columnTitle: "Katherine > Jabiru",
    columnDay: "Day 7",
    activities: [
      {
        tags: ["highlight"],
        id: "windolf-walk",
        label: "Windolf Walk - Katherine Gorge",
        imageName: "katherineGorge.jpg",
        notes: `<h4>Grade 3 | Moderate</h4><p>Around 4 hours</p><p>
        There are several tracks to take here. We took Windolf Walk but then also went towards Jedda's Rock. This was by far the most tiring walk we did. It was very humid and hot and few people around. You need to be very careful to follow the tracks because the path is not super clear at times, very bushy. You can easily get lost. Nonetheless, we had a lots of fun and the lookouts are incredible.
        Find more info and maps on: <a target="_blank" href="https://nt.gov.au/leisure/parks-reserves/plan-your-visit/bushwalking-hiking/walks-nitmiluk-national-park">Walks Nitmiluk National Park</a>
        <br/> Do it really early to avoid the heat!
        </p>`
      },
      {
        tags: [],
        id: "nitmiluk-visitor-center",
        label: "Nitmiluk Visitor Center"
      },
      {
        tags: ["highlight"],
        id: "edith-falls",
        label: "Edith Falls",
        imageName: "edithFalls.jpg",
        notes: `<p>The area is great for bushwalking with the 2.6 kilometre Leliyn Trail offering a challenging walk along a steep, rocky loop. There is a chance for a refreshing swim in the upper pool of Leliyn / Edith Falls half way around the trail. You can also enjoy the longer 9 kilometre return walk to Sweetwater Pool, a tranquil swimming hole.

        Opening times
        Daily, 24 hours.
        Info from: <a target="_blank" href="https://northernterritory.com/us/en/katherine-and-surrounds/see-and-do/leliynedith-falls?utm_source=tourismnt&utm_medium=redirect&utm_campaign=old.northernterritory.com&utm_term=/en-us/katherine-and-surrounds/things-to-do/leliynedith-falls&utm_content=">Leliyn Edith Falls</a></p>
        
        <p>Notes: It's amazing to swim on! Specially after the walk from before.</p>
        `
      },
      {
        tags: ["drive"],
        id: "katherine-jabiru",
        label: "Katherine - Jabiru"
      },
      {
        tags: [],
        id: "bowali-visitor-center",
        label: "Bowali Visitor Center"
      },
      {
        tags: ["highlight"],
        id: "ubirr",
        label: "Ubirr",
        imageName: "ubirr.jpg",
        notes: `<p>Ubirr is one of Kakadu National Park's two most famous Aboriginal rock art galleries</p>
        <p>
        The walk to Ubirr takes about an hour and is 1 kilometre via a circular walking track from the car park. The climb to the lookout takes a further 30 minutes. During the tropical summer months access is restricted - check with the Bowali Visitor Centre for the latest information.</p>
        
        <p>An entry fee is required to enter Kakadu National Park. 
        
        Daily May to November from 8.30am to sunset. From December to April 2pm to sunset.
        
        Info from: <a target="_blank" href="https://parksaustralia.gov.au/kakadu/do/walks/ubirr-walk/">Ubirr Walk</a><p>
        
        <p>Notes: Ubirr is not only incredible because of it's aboriginal art, it's the border with Arnhem Land and the views are breathtaking. Watch the sunset there!</p>`
      },
      {
        tags: ["sleep"],
        id: "mercure-kakadu-hotel",
        label: "Mercure Kakadu Hotel (Jabiru)"
      }
    ]
  },
  "Day 8": {
    columnTitle: "Jabiru > Darwin",
    columnDay: "Day 8",
    activities: [
      {
        tags: ["highlight"],
        id: "yellow-water-cruise",
        label: "Yellow Water Cruise",
        imageName: "yellowWater.jpg",
        notes: `A bit pricey, but worth it. This cruise takes you along the yellow water river and you get to see up close a lot of the animals that inhabit this area. (Lots of crocs)
        Info on: <a target="_blank" href="https://kakadutourism.com/trip-planning/tours-activities/yellow-water-cruises">Yellow Water Cruises</a>
        `
      },
      {
        tags: ["highlight"],
        id: "burrungkuy",
        label: "Burrungkuy",
        imageName: "burrungkuy.jpg",
        notes: `<p>The walls of the Burrungkuy (Nourlangie) rock art site, in World Heritage-listed Kakadu National Park, have served as a shelter and canvas for thousands of years.<p>
        <p>Info from: <a target="_blank" href="https://northernterritory.com/us/en/kakadu-and-surrounds/destinations/burrungkuy--rock-art-site">Burrungkuy Art Site</a></p>`
      },
      {
        tags: ["drive"],
        id: "jabiru-darwin",
        label: "Jabiru - Darwin"
      },
      {
        tags: ["extras"],
        id: "crocosaurus-cove",
        label: "Crocosaurus Cove"
      },
      {
        tags: ["highlight"],
        id: "mindil-market",
        label: "Mindil Market",
        notes: `Held every Thursday and Sunday from 4 p.m.-9 p.m. Supporting over 300 small businesses and employing over 1000 locals, the Mindil Market is a Darwin institution, packed with cultural arts and crafts, soaps, perfumes, clothing, jewelry and everything in between. The vast selection of food and handmade goods is a testament to the fifty different nationalities that call Darwin home.
        `
      },
      {
        tags: [],
        id: "cullen-bay",
        label: "Cullen Bay Marina"
      },
      {
        tags: ["extras"],
        id: "crocodylus-park",
        label: "Crocodylus Park"
      },
      {
        tags: ["sleep"],
        id: "oaks-hotel",
        label: "Oaks Hotel (Darwin)",
        imageName: "darwin.jpg"
      }
    ]
  },
  "Day 9": {
    columnTitle: "Fly back home",
    columnDay: "Day 9",
    activities: [
      {
        tags: ["flight"],
        id: "flight-home",
        label: "Flight from Darwin Airport"
      }
    ]
  }
};